import carteBancaireLogo from "../components/assets/appImage/financerCampageImg4.png";
import celtiisLogo from "../components/assets/appImage/paydunyaCeltiis.png";
import djamoLogo from "../components/assets/appImage/paydunyaDjamo.png";
import emoneyLogo from "../components/assets/appImage/paydunyaEmoney.png";
import freeMoneyLogo from "../components/assets/appImage/paydunyaFreeMoney.png";
import moovLogo from "../components/assets/appImage/paydunyaMoov.png";
import mtnLogo from "../components/assets/appImage/paydunyaMtn.png";
import orangeMoneyLogo from "../components/assets/appImage/paydunyaOrangeMoney.png";
import tmoneyLogo from "../components/assets/appImage/paydunyaTmoney.png";
import waveLogo from "../components/assets/appImage/paydunyaWave.png";
import wizallLogo from "../components/assets/appImage/paydunyaWizall.png";
import { PAYMENT_TYPE } from "./api/launchCampagn/projet.type";

export type PaydunyaChannel = {
  slug: PAYMENT_TYPE;
  label: string;
  logo?: string;
};

export type PaydunyaCountry = {
  code: string;
  name: string;
  flag: string;
  channels: PaydunyaChannel[];
};

export const CARTE_BANCAIRE: PaydunyaChannel = {
  slug: "card",
  label: "carte bancaire",
  logo: carteBancaireLogo,
};

// Opérateurs mobile money supportés par Paydunya, regroupés par pays.
// Les slugs proviennent de la section 8 de https://developers.paydunya.com/doc/FR/introduction
// et doivent être envoyés tels quels à l'API (clé "channels" de la facture).
export const PAYDUNYA_COUNTRIES: PaydunyaCountry[] = [
  {
    code: "SN",
    name: "Sénégal",
    flag: "🇸🇳",
    channels: [
      { slug: "orange-money-senegal", label: "Orange Money", logo: orangeMoneyLogo },
      { slug: "wave-senegal", label: "Wave", logo: waveLogo },
      { slug: "free-money-senegal", label: "Free Money", logo: freeMoneyLogo },
      { slug: "expresso-sn", label: "E-Money Expresso", logo: emoneyLogo },
      { slug: "wizall-senegal", label: "Wizall", logo: wizallLogo },
      { slug: "djamo-sn", label: "Djamo", logo: djamoLogo },
    ],
  },
  {
    code: "CI",
    name: "Côte d'Ivoire",
    flag: "🇨🇮",
    channels: [
      { slug: "orange-money-ci", label: "Orange Money", logo: orangeMoneyLogo },
      { slug: "wave-ci", label: "Wave", logo: waveLogo },
      { slug: "mtn-ci", label: "MTN MoMo", logo: mtnLogo },
      { slug: "moov-ci", label: "Moov Money", logo: moovLogo },
      { slug: "djamo-ci", label: "Djamo", logo: djamoLogo },
    ],
  },
  {
    code: "BJ",
    name: "Bénin",
    flag: "🇧🇯",
    channels: [
      { slug: "mtn-benin", label: "MTN MoMo", logo: mtnLogo },
      { slug: "moov-benin", label: "Moov Money", logo: moovLogo },
      { slug: "celtiis-cash", label: "Celtiis Cash", logo: celtiisLogo },
    ],
  },
  {
    code: "TG",
    name: "Togo",
    flag: "🇹🇬",
    channels: [
      { slug: "t-money-togo", label: "T-Money", logo: tmoneyLogo },
      { slug: "moov-togo", label: "Moov Money", logo: moovLogo },
    ],
  },
  {
    code: "ML",
    name: "Mali",
    flag: "🇲🇱",
    channels: [
      { slug: "orange-money-mali", label: "Orange Money", logo: orangeMoneyLogo },
      { slug: "moov-ml", label: "Moov Money", logo: moovLogo },
    ],
  },
  {
    code: "BF",
    name: "Burkina Faso",
    flag: "🇧🇫",
    channels: [
      { slug: "orange-money-burkina", label: "Orange Money", logo: orangeMoneyLogo },
      { slug: "moov-burkina-faso", label: "Moov Money", logo: moovLogo },
    ],
  },
  {
    code: "CM",
    name: "Cameroun",
    flag: "🇨🇲",
    channels: [{ slug: "mtn-cameroun", label: "MTN MoMo", logo: mtnLogo }],
  },
];

export const getPaydunyaCountry = (code: string) =>
  PAYDUNYA_COUNTRIES.find((c) => c.code === code);
